export default __webpack_public_path__ + "static/media/i-360video-sura.c3868c1a.svg";